import { payload } from "../../../../../node_modules/.pnpm/@sveltejs+kit@3.1.0_@opentelemetry+api@1.9.1_@sveltejs+vite-plugin-svelte@7.3.0_svelte@_b85183d83ad94a8c9ca36bf950d489dd/node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_BASE_URL = env.PUBLIC_BASE_URL;
export const PUBLIC_SENTRY_DSN = env.PUBLIC_SENTRY_DSN;
export const PUBLIC_POSTHOG_KEY = env.PUBLIC_POSTHOG_KEY;
export const PUBLIC_BUCKETS = env.PUBLIC_BUCKETS;
export const PUBLIC_SUPABASE_URL = env.PUBLIC_SUPABASE_URL;
export const PUBLIC_SUPABASE_ANON_KEY = env.PUBLIC_SUPABASE_ANON_KEY;
